import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { isSameCityLocation } from '@/lib/getCitySlugAction';

export default function useLocationNavigation() {
  const router = useRouter();
  const [pendingUrl, setPendingUrl] = useState<string | null>(null);

  useEffect(() => {
    const start = (url: string, { shallow }: { shallow: boolean }) => {
      if (!shallow && !isSameCityLocation(router.asPath, url)) setPendingUrl(url);
    };
    const finish = (url: string) => {
      setPendingUrl((pending) => (pending === url ? null : pending));
    };
    const error = (_error: unknown, url: string) => finish(url);

    router.events.on('routeChangeStart', start);
    router.events.on('routeChangeComplete', finish);
    router.events.on('routeChangeError', error);
    return () => {
      router.events.off('routeChangeStart', start);
      router.events.off('routeChangeComplete', finish);
      router.events.off('routeChangeError', error);
    };
  }, [router]);

  return pendingUrl !== null;
}
